// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-selector-container {
    text-align: center;
  }
  
  .options {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  
  .option {
    cursor: pointer;
    padding: 10px 20px;
    margin: 0 10px;
    border: 2px solid transparent;
    border-radius: 5px;
    transition: all 0.3s ease;
  }
  
  .option:hover {
    background-color: #f0f0f0;
  }
  
  .option.selected {
    background-color: #4caf50;
    color: white;
  }
  
  .option.selected:hover {
    background-color: #388e3c;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/OptionSelector.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".option-selector-container {\n    text-align: center;\n  }\n  \n  .options {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n  }\n  \n  .option {\n    cursor: pointer;\n    padding: 10px 20px;\n    margin: 0 10px;\n    border: 2px solid transparent;\n    border-radius: 5px;\n    transition: all 0.3s ease;\n  }\n  \n  .option:hover {\n    background-color: #f0f0f0;\n  }\n  \n  .option.selected {\n    background-color: #4caf50;\n    color: white;\n  }\n  \n  .option.selected:hover {\n    background-color: #388e3c;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
